'use strict';
const isMobile = Odigeo.SessionScope.flow === 'mobile';

const SEGMENT = {
    FIRST: 0,
    SECOND: 1,
    THIRD: 2,
    FOURTH: 3,
    FIFTH: 4,
    SIXTH: 5,
};

const APPLICATION_LEVEL = {
    SECTION: 'SECTION',
    SEGMENT: 'SEGMENT',
    ITINERARY: 'ITINERARY',
};

const SEARCH_REQUEST_TYPE = {
    ONE_WAY: 'ONE_WAY',
    ROUND_TRIP: 'ROUND_TRIP',
    MULTIPLE_DESTINATIONS: 'MULTIPLE_DESTINATIONS',
};

const getIataInfo = (prefix, rawData) => {
    return {
        iata: rawData[`${prefix}Iata`],
        cityIata: rawData[`${prefix}CityIata`],
        cityName: rawData[`${prefix}City`],
    };
};

module.exports = Backbone.Model.extend({
    defaults: {
        doesAnySegmentHaveASelectableBaggage: false,
        requestType: null,
        idPassenger: -1,
        carrierCode: null,
        hasIncludedBaggage: false,
        hasSelectableBaggage: false,
        applicationLevel: null,
        options: [],
        isSelected: false,
        selectedBaggage: undefined,
        autoSelectionActive: false,
        selectedPrice: 0,
        selectedPieces: 0,
        segment: null,
        departure: {
            iata: null,
            cityIata: null,
            cityName: null,
        },
        arrival: {
            iata: null,
            cityIata: null,
            cityName: null,
        },
    },

    initialize() {
        this.listenTo(this, 'change:selectedBaggage', this.updateSelectedBaggageInfo);
    },

    setData(rawData) {
        rawData = rawData || {};
        const requestType = SEARCH_REQUEST_TYPE[rawData.requestType];
        const rowCollectionId = Odigeo._.get(rawData.rowDescriptor, 'cid');
        const rowDescriptor = Odigeo._.get(rawData, 'rowDescriptor.attributes') || rawData.rowDescriptor;
        const idPassenger = rowDescriptor.idPassenger !== undefined ? rowDescriptor.idPassenger : -1;
        const carrierCode = rowDescriptor.carrierCode;
        const hasIncludedBaggage = rowDescriptor.hasIncludedBaggages;
        const hasSelectableBaggage = rowDescriptor.hasSelectableBaggages;
        const shouldDisplayGenericLogo = rowDescriptor.shouldDisplayGenericLogo;
        const offerAdditionalBaggage = hasIncludedBaggage && hasSelectableBaggage;
        const idRow = rowDescriptor.idRow;
        const segment = SEGMENT[idRow];
        const autoSelectionActive = rawData.autoSelectionActive;
        const applicationLevel = APPLICATION_LEVEL[rowDescriptor.baggageApplicationLevel];
        const selectedBaggage = rawData.selected || null;
        const doesAnySegmentHaveASelectableBaggage = rawData.doesAnySegmentHaveASelectableBaggage || false;
        const options = rawData.options || [];
        const departure = getIataInfo('departure', rowDescriptor);
        const arrival = getIataInfo('arrival', rowDescriptor);
        const debugInfo = rowDescriptor.debugInfo || undefined;

        this.set({
            requestType,
            idPassenger,
            carrierCode,
            hasIncludedBaggage,
            hasSelectableBaggage,
            offerAdditionalBaggage,
            rowCollectionId,
            applicationLevel,
            options,
            selectedBaggage,
            segment,
            idRow,
            autoSelectionActive,
            departure,
            arrival,
            shouldDisplayGenericLogo,
            doesAnySegmentHaveASelectableBaggage,
            debugInfo,
        });
    },

    updateSelectedBaggageInfo(model, selectedBaggage) {
        const selectedPieces = selectedBaggage ? selectedBaggage.get('pieces') : 0;
        const isSelected = selectedPieces > 0;
        const selectedRawPrice = selectedBaggage ? selectedBaggage.get('price') : 0;
        const selectedPrice = Odigeo.Utils.formatCurrency(this.calculateSelectedPrice(selectedRawPrice));
        const selectedRawPrimePrice = selectedBaggage ? selectedBaggage.get('primePrice') : 0;
        const selectedPrimePrice = Odigeo.Utils.formatCurrency(this.calculateSelectedPrice(selectedRawPrimePrice));
        const selectedWeight = isSelected ? selectedBaggage.get('kilos') : 0;

        this.set({
            isSelected,
            selectedPieces,
            selectedRawPrice,
            selectedPrice,
            selectedRawPrimePrice,
            selectedPrimePrice,
            selectedWeight,
        });
    },

    calculateSelectedPrice(selectedPrice) {
        return selectedPrice > 0 && this.shouldSplitPrice() ? selectedPrice / 2 : selectedPrice;
    },

    isOneWay() {
        return this.get('requestType') === SEARCH_REQUEST_TYPE.ONE_WAY;
    },

    isRoundTrip() {
        return this.get('requestType') === SEARCH_REQUEST_TYPE.ROUND_TRIP;
    },

    isMultiTrip() {
        return this.get('requestType') === SEARCH_REQUEST_TYPE.MULTIPLE_DESTINATIONS;
    },

    hasApplicationLevelItinerary() {
        return this.get('applicationLevel') === APPLICATION_LEVEL.ITINERARY;
    },

    hasSelectableBaggage() {
        return this.get('hasSelectableBaggage');
    },

    hasIncludedBaggage() {
        return this.get('hasIncludedBaggage');
    },

    hasAutoSelectionActive() {
        return this.get('autoSelectionActive');
    },

    doesAnySegmentHaveASelectableBaggage() {
        return this.get('doesAnySegmentHaveASelectableBaggage');
    },

    shouldSplitPrice() {
        const isItinerary = this.hasApplicationLevelItinerary();
        const isRoundTrip = this.isRoundTrip();
        const isMultipleDestinations = this.isMultiTrip();
        const isDisplayedAsItinerary = isItinerary && (isRoundTrip || isMultipleDestinations);
        return isDisplayedAsItinerary && (!isMobile || Odigeo.AB.isDisplayPricePerFlightItineraryMobile);
    },

    isSecondLeg() {
        return this.get('segment') === 1;
    },
});
